import { Rise } from "@/components/humble/AnimatedText";
import { HUMBLE } from "@/constants/testIds";

/**
 * Pull-quote — quiet faith thread. Cream backing so it doesn't wash out the section behind it.
 */
export default function PullQuote() {
  return (
    <section
      aria-label="Pull quote"
      data-testid={HUMBLE.pullQuote}
      className="relative isolate overflow-hidden bg-cream text-earth"
    >
      <div className="mx-auto w-full max-w-[1100px] px-6 py-24 md:px-12 md:py-36 text-center">
        <Rise>
          <div className="mb-8 flex items-center justify-center gap-3 font-body uppercase text-[11px] tracking-[0.42em] text-earth/50">
            <span className="inline-block h-px w-10 bg-earth/30" />
            an old, quiet line
            <span className="inline-block h-px w-10 bg-earth/30" />
          </div>
        </Rise>
        <Rise delay={0.08}>
          <blockquote className="font-display italic text-[34px] leading-[1.15] tracking-tight text-earth md:text-[52px] lg:text-[64px]">
            &ldquo;Consider the lilies,
            <br className="hidden md:block" /> how they grow.&rdquo;
          </blockquote>
        </Rise>
        <Rise delay={0.16}>
          <div className="mt-8 font-body uppercase text-[11px] tracking-[0.4em] text-earth/50">
            — Luke 12:27
          </div>
        </Rise>
      </div>
    </section>
  );
}
